import React from "react";
import LoginForm from "../components/LoginForm";

function Login() {
    return <div className=" vh-100 vw-100 d-flex"><LoginForm /></div>;
}
export default Login;